export default __webpack_public_path__ + "static/media/game3Demo.14c7692e.png";